import * as types from "../../mutationTypes";
import productService from "services/productService";

const actions = {
  async getAll ({ commit, state, dispatch }, force) {
    if (!state.items || state.items.length === 0 || force) {
      dispatch('app/loadingDataEnable', 'codeListItems', {root: true});
      const products = await productService.findAll();
      await commit(types.PRODUCT_LIST, {
        items: products || []
      });
      dispatch('app/loadingDataDisable', 'codeListItems', {root: true});
    }
  },
  async create ({dispatch, commit}, product) {
    let newProduct = await productService.create(product);
    if (newProduct) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async update ({dispatch, commit}, product) {
    let updatedProduct = await productService.update(product);
    if (updatedProduct) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async delete ({dispatch, commit}, id) {
    try {
      let response = await productService.delete(id);
      if (response.ok) {
        dispatch('getAll', true);
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async deactivate ({ dispatch }, id) {
    let response = await productService.deactivate(id);
    if (response.ok) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async activate ({ dispatch }, id) {
    let response = await productService.activate(id);
    if (response.ok) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  }
};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/product/productActions.js